import { useState, useCallback } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as actions from '@actions'
import * as store from '@store'
import useAbortableFetch from '@hook/useAbortableFetch'

import WellsTable from './WellsTable'
import CircleSpinner from '@components/shared/CircleSpinner'
import Pagination from '@components/shared/Pagination'
import SearchInput from '@components/shared/SearchInput'

import { updateSearchParam } from '@/components/shared/utils'
import { useSearchParams } from 'react-router-dom'

import './Wells.css'
import { MdFileDownload } from 'react-icons/md'
import { toast } from 'react-toastify'
import { createSyntheticDownload } from '@/utils'

const wellsPerPage = 100

const Wells = () => {
    
    const [loading, setLoading] = useState(false)
    const [exportLoading, setExportLoading] = useState(false)
    const [wells, setWells] = useState({})
    const [pageIndex, setPageIndex] = useState(0)
    const currentOrganization = useWireValue(store.currentOrganization)
    const [searchParams, setSearchParams] = useSearchParams({
        query: '',
        order: 'DESC',
    })
    
    const setQuery = query => setSearchParams(updateSearchParam('query', query))
    
    const changeOrder = () => searchParams.get('order') === 'DESC'
        ? setSearchParams(updateSearchParam('order', 'ASC'))
        : setSearchParams(updateSearchParam('order', 'DESC'))
    
    const fetchWells = useCallback(async (query, order, pageIndex) => {
        
        setLoading(true)
        
        try {
            
            const res = await actions.fetchAllCheckWells({
                query,
                order,
                offset: (pageIndex * wellsPerPage),
                limit: wellsPerPage,
            })
            
            setWells(res)
            
        } catch (e) {
            
            // @todo show error
            console.error('Wells#effect.fetchAllCheckWells', e)
            
        }
        
        setLoading(false)
        
    }, [currentOrganization])
    
    const exportWells = async () => {
        setExportLoading(true)
        
        const res = await actions.exportWells(searchParams.get('query'))
        
        if (res)
            createSyntheticDownload(res.data, res.headers['content-type'], res.headers['content-name'])
        else
            toast.error('Failed to export Wells List, please try again.')
        
        setExportLoading(false)
    }
    
    useAbortableFetch(() =>
        fetchWells(searchParams.get('query'), searchParams.get('order'), pageIndex),
    [searchParams, pageIndex, currentOrganization])
    
    return (
        
        <div className="Wells">
            
            <header className="mt-2">
                <SearchInput
                    className="w-full grow search-query"
                    value={searchParams.get('query')}
                    placeholder="Search wells..."
                    onKeyUp={e => e.key === 'Escape' && setQuery('')}
                    onChange={e => setQuery(e.target.value)} />
                <button className="btn btn-primary" onClick={exportWells} disabled={exportLoading}>
                    <MdFileDownload />Export
                </button>
            </header>
            
            <div className="mt-4 table-wrap">
                {loading && !wells?.rows?.length && (
                    <CircleSpinner className="absolute-centered" />
                )}
                {!loading && <WellsTable
                    wells={wells}
                    order={searchParams.get('order')}
                    changeOrder={changeOrder} />
                }
            </div>
            <div className="flex mt-4 justify-center">
                {!loading && <Pagination
                    count={wells?.count}
                    itemsPerPage={100}
                    setPageIndex={setPageIndex} />
                }
            </div>
            
            {/* <div><pre><code className="text-white">{JSON.stringify(wells, null, 4)}</code></pre></div> */}
        
        </div>
        
    )
    
}

export default Wells
